<template>
  <v-progress-linear
    fixed
    :active="progress"
    indeterminate
    class="main-progress"
  ></v-progress-linear>
</template>
<style scoped>
.v-progress-linear--absolute,
.v-progress-linear--fixed {
  z-index: 9999;
}
</style>
<script>
export default {
  computed: {
    progress() {
      return this.$store.state.feedbackProgress;
    },
  },
};
</script>